import {createSelector} from 'reselect';
import {serviceAddress} from 'src/shared/user/selectors';
import {stringifyAddress} from 'src/pages/localChannelLineup/store/utils/stringifyAddress';

export const stateAddress = state => state.address;

export const address = createSelector(
  [stateAddress, serviceAddress],
  (stateAddress, serviceAddress) => {
    if (stateAddress !== null) {
      return stateAddress;
    }
    return stringifyAddress(serviceAddress);
  }
);
